import { axiosBase } from 'utils';

const axios = axiosBase.create();

export function rackDeviceListService() {
  return axios.get('/rackdevice');
}

export function rackDeviceSearchService(q) {
  if (q === '') {
    return axios.get('/rackdevice');
  }
  return axios.get('/rackdevice/search?q=' + encodeURIComponent(q));
}

export function rackDeviceCreateService(data) {
  return axios.post('/rackdevice', data);
}

export function rackDeviceDeleteService(id) {
  return axios.delete(`/rackdevice/${id}`);
}

export function rackDeviceUpdateService(id, data) {
  return axios.patch(`/rackdevice/${id}`, data);
}

export function rackDeviceGetByIdService(id) {
  return axios.get(`/rackdevice/${id}`);
}

export function getVendorsListService() {
  return axios.get('/rackdevice/vendors/list');
}

export function getModelsByVendorService(vendorId) {
  return axios.get(`/rackdevice/models/by-vendor/${vendorId}`);
}

export function getDevicesByVendorAndModelService(vendorId, modelId) {
  return axios.get(`/rackdevice/devices/vendor/${vendorId}/model/${modelId}`);
}
